import NextLink, { LinkProps as NextLinkProps } from 'next/link'
import { useRouter } from 'next/router'
import { AnchorHTMLAttributes, FC, PropsWithChildren, Ref } from 'react'

interface LinkProps
  extends NextLinkProps,
    Omit<AnchorHTMLAttributes<HTMLAnchorElement>, keyof NextLinkProps> {
  exact?: boolean
  ref?: Ref<HTMLAnchorElement | null>
  'aria-label'?: string
}

export const Link: FC<PropsWithChildren<LinkProps>> = ({
  exact = false,
  href,
  children,
  ref,
  'aria-label': ariaLabel,
  ...props
}) => {
  const { network } = useRouter().query

  const shouldAddNetwork = !!network && !exact

  let linkHref = href

  if (shouldAddNetwork) {
    // href could be string or UrlObject from next/link
    if (typeof href === 'string') {
      linkHref = `/n/${network}${href}`
    } else {
      linkHref = {
        ...href,
        pathname: `/n/${network}${href.pathname}`
      }
    }
  }

  return (
    <NextLink href={linkHref} ref={ref} {...props} aria-label={ariaLabel}>
      {children}
    </NextLink>
  )
}
